import { Dashboard, DirectionsCar, AdminPanelSettings, Gavel, DateRange, Settings, CenterFocusStrong, Add, Help, Feedback, History, Queue, Remove, MiscellaneousServices } from "@mui/icons-material";
import GroupsIcon from "@mui/icons-material/Groups";
import GavelIcon from "@mui/icons-material/Gavel";
import { RouteInfo } from "./sidebar-interface";
// Sidebar icons
import { ReactComponent as Pcn } from "../../assets/SVG/layout/Pcnicon.svg";
import { ReactComponent as Payment } from "../../assets/SVG/layout/payment.svg";
import { ReactComponent as FindParking } from "../../assets/SVG/layout/findparking.svg";
import { ReactComponent as Traficrule } from "../../assets/SVG/layout/traficrule.svg";
import { ReactComponent as Manage } from "../../assets/SVG/layout/manage.svg";
import { ReactComponent as ActiveAcc } from "../../assets/SVG/layout/activityaccount.svg";
import { ReactComponent as Apiinventory } from "../../assets/SVG/layout/apiinventory.svg";
import { ReactComponent as Thirdpartylicence } from "../../assets/SVG/layout/thirdParty.svg";
import { ReactComponent as Performance } from "../../assets/SVG/layout/systemperformance.svg";
import { ReactComponent as Auditlog } from "../../assets/SVG/layout/newsletter.svg";
import { ReactComponent as Newsletter } from "../../assets/SVG/layout/newsletter1.svg";
import { ReactComponent as RatingFeedback } from "../../assets/SVG/layout/RatingFeedback.svg";
import { ReactComponent as Ihelpdesk } from "../../assets/SVG/layout/Ithelpdesk.svg";
import { ReactComponent as Canclerequest } from "../../assets/SVG/layout/CancleReq.svg";
import { ReactComponent as Completedrequest } from "../../assets/SVG/layout/CompletedReq.svg";
import { ReactComponent as PendingRequest } from "../../assets/SVG/layout/PendingReq.svg";
import { ReactComponent as Newrequest } from "../../assets/SVG/layout/Newrequest.svg";
import { ReactComponent as Enquiry } from "../../assets/SVG/layout/enquiry.svg";

export const ROUTES: RouteInfo[] = [
  //  Dashboard Component for personal user and employee
  {
    path: "/",
    title: "Dashboard",
    toShowForRole: ["Personal", "Employee"],
    icon: <Dashboard />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  //  Dashboard for commercial and corporate
  {
    path: "/c-dashboard",
    title: "Dashboard",
    toShowForRole: ["Corporate", "Commercial"],
    icon: <Dashboard />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  //  Data for system Admin
  {
    path: "/system-admin-dashboard",
    toShowForRole: ["Admin"],
    title: "Dashboard",
    icon: <Dashboard />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/admin",
    title: "Manage",
    toShowForRole: ["Admin"],
    icon: <GroupsIcon />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,

    submenu: [
      {
        path: "/admin/manage-users",
        title: "Manage Users",
        hideIcon: <Queue />,
        toShowForRole: ["Admin"],
      },
      {
        path: "/admin/manage-third-party-users",
        title: "Manage Third-Party Users",
        hideIcon: <History />,
        toShowForRole: ["Admin"],
      },
      {
        path: "/admin/manage-newUsers",
        title: "New Users",
        hideIcon: <Queue />,
        toShowForRole: ["Admin"],
      },
    ],
  },
  {
    path: "/api-inventory",
    toShowForRole: ["Admin"],
    title: "API Inventory",
    icon: <Apiinventory />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/third-party-licenses",
    toShowForRole: ["Admin"],
    title: "Third-Party Licenses",
    icon: <Thirdpartylicence />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/system-performance",
    toShowForRole: ["Admin"],
    title: "System Performance",
    icon: <Performance />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/newsletter",
    toShowForRole: ["Admin"],
    title: "Newsletter",
    icon: <Newsletter />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/audit-logs",
    toShowForRole: ["Admin"],
    title: "Audit Logs",
    icon: <Auditlog />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/third-party-dashboard",
    toShowForRole: ["Insurance Companies", "MOT Centres", "Motor Dealers", "Motor Auctioneers", "Salvage Dealers", "Finance Companies", "Fleet Operators", "Car Buying Services"],
    title: "Dashboard",
    icon: <Dashboard />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/new-requests",
    toShowForRole: ["Insurance Companies", "MOT Centres", "Motor Dealers", "Motor Auctioneers", "Salvage Dealers", "Finance Companies", "Fleet Operators", "Car Buying Services"],
    title: "New Requests",
    icon: <Newrequest />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/pending-requests",
    toShowForRole: ["Insurance Companies", "MOT Centres", "Motor Dealers", "Motor Auctioneers", "Salvage Dealers", "Finance Companies", "Fleet Operators", "Car Buying Services"],
    title: "Pending Requests",
    icon: <PendingRequest />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/completed-requests",
    toShowForRole: ["Insurance Companies", "MOT Centres", "Motor Dealers", "Motor Auctioneers", "Salvage Dealers", "Finance Companies", "Fleet Operators", "Car Buying Services"],
    title: "Completed Requests",
    icon: <Completedrequest />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/cancelled-requests",
    toShowForRole: ["Insurance Companies", "MOT Centres", "Motor Dealers", "Motor Auctioneers", "Salvage Dealers", "Finance Companies", "Fleet Operators", "Car Buying Services"],
    title: "Cancelled Requests",
    icon: <Canclerequest />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/ratings",
    toShowForRole: ["Admin", "Insurance Companies", "MOT Centres", "Motor Dealers", "Motor Auctioneers", "Salvage Dealers", "Finance Companies", "Fleet Operators", "Car Buying Services"],
    title: "Ratings & Feedback",
    icon: <RatingFeedback />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/it-help-desk",
    toShowForRole: ["Admin"],
    title: "IT Help Desk",
    icon: <Ihelpdesk />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/my-vehicles",
    title: "My Vehicles",
    toShowForRole: ["Personal", "Employee"],
    icon: <DirectionsCar />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/manage",
    title: "Manage",
    toShowForRole: ["Commercial", "Corporate"],
    icon: <Manage />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,

    submenu: [
      {
        path: "/manage/manage-employees",
        title: "Manage Employees",
        hideIcon: <GroupsIcon />,
        toShowForRole: ["Corporate"],
      },
      {
        path: "/manage/manage-employees",
        title: "Manage Customers",
        hideIcon: <GroupsIcon />,
        toShowForRole: ["Commercial"],
      },
      {
        path: "/manage/manage-vehicles",
        title: "Manage Vehicles",
        hideIcon: <DirectionsCar />,
        toShowForRole: ["Corporate", "Commercial"],
      },
      {
        path: "/manage/manage-cost-centres",
        title: "Manage Cost Centres",
        hideIcon: <CenterFocusStrong />,
        toShowForRole: ["Corporate", "Commercial"],
      },
      {
        path: "/manage/manage-administrators",
        title: "Manage Administrators",
        hideIcon: <AdminPanelSettings />,
        toShowForRole: ["Corporate", "Commercial"],
      },
    ],
  },
  {
    path: "/pcn",
    title: "PCN",
    toShowForRole: ["Personal", "Commercial", "Corporate", "Employee"],
    icon: <Pcn />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/park-a-customer",
    title: "Park A Customer",
    toShowForRole: ["Commercial"],
    icon: <FindParking />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/park-an-employee",
    title: "Park An Employee",
    toShowForRole: ["Corporate"],
    icon: <FindParking />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/payments",
    title: "Payments",
    toShowForRole: ["Personal", "Commercial", "Corporate", "Employee"],
    icon: <Payment />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/appeal-process",
    title: "Appeals",
    toShowForRole: ["Personal", "Commercial", "Corporate", "Employee"],
    icon: <Gavel />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/find",
    title: "Find Parking Near Me",
    toShowForRole: ["Personal", "Employee"],
    icon: <FindParking />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,

    submenu: [
      {
        path: "/find/book-a-new-session",
        title: "Book A New Session",
        hideIcon: <Queue />,
        toShowForRole: ["Personal", "Employee"],
      },
      {
        path: "/find/booking-history",
        title: "Booking History",
        hideIcon: <History />,
        toShowForRole: ["Personal", "Employee"],
      },
    ],
  },

  {
    path: "/lawyers-dashboard",
    title: "Dashboard",
    toShowForRole: ["Lawyers"],
    icon: <Dashboard />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/my-clients",
    title: "Clients",
    toShowForRole: ["Lawyers"],
    icon: <GroupsIcon />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/appeals",
    title: "Appeals",
    toShowForRole: ["Lawyers"],
    icon: <GavelIcon />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
    submenu: [
      {
        path: "/appeals/formal-challenge",
        title: "Formal Challenge",
        hideIcon: <Queue />,
        toShowForRole: ["Lawyers"],
      },
      {
        path: "/appeals/independent-tribunals",
        title: "Independent Tribunals",
        hideIcon: <History />,
        toShowForRole: ["Lawyers"],
      },
    ],
  },

  {
    path: "/account-activity",
    title: "Account Activity",
    toShowForRole: ["Commercial", "Corporate"],
    icon: <ActiveAcc />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/calender",
    title: "Calendar",
    toShowForRole: [
      "Personal",
      "Commercial",
      "Corporate",
      "Employee",
      "ThirdParty",
      "Lawyers",
      "Insurance Companies",
      "MOT Centres",
      "Motor Dealers",
      "Motor Auctioneers",
      "Salvage Dealers",
      "Finance Companies",
      "Fleet Operators",
      "Car Buying Services",
    ],
    icon: <DateRange />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/personal-services",
    title: "Services",
    toShowForRole: ["Personal", "Commercial", "Corporate"],
    icon: <MiscellaneousServices />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },
  {
    path: "/traffic-rules",
    toShowForRole: [
      "Personal",
      "Commercial",
      "Corporate",
      "Employee",
      "Admin",
      "ThirdParty",
      "Lawyers",
      "Insurance Companies",
      "MOT Centres",
      "Motor Dealers",
      "Motor Auctioneers",
      "Salvage Dealers",
      "Finance Companies",
      "Fleet Operators",
      "Car Buying Services",
    ],
    title: "Traffic Rules",
    icon: <Traficrule />,
    openendMenu: <Add sx={{ fontSize: "21px", color: "white" }} />,
    closedMenu: <Remove sx={{ fontSize: "21px", color: "white" }} />,
  },

  //System Admin Sidebar data
];
//Profile icon menus like logout, my account etc
export const AvatarData: RouteInfo[] = [
  {
    title: "My Account",
    path: "/setting",
    toShowForRole: [
      "Personal",
      "Employee",
      "Commercial",
      "Corporate",
      "Admin",
      "Lawyers",
      "Insurance Companies",
      "MOT Centres",
      "Motor Dealers",
      "Motor Auctioneers",
      "Salvage Dealers",
      "Finance Companies",
      "Fleet Operators",
      "Car Buying Services",
    ],
    icon: <Settings />,
  },
  {
    title: "Help",
    path: "/help",
    toShowForRole: [
      "Personal",
      "Employee",
      "Commercial",
      "Corporate",
      "Admin",
      "Lawyers",
      "Insurance Companies",
      "MOT Centres",
      "Motor Dealers",
      "Motor Auctioneers",
      "Salvage Dealers",
      "Finance Companies",
      "Fleet Operators",
      "Car Buying Services",
    ],
    icon: <Help />,
  },
  {
    title: "My Enquires",
    path: "my-enquiries",
    toShowForRole: [
      "Personal",
      "Employee",
      "Commercial",
      "Corporate",
      "Lawyers",
      "Insurance Companies",
      "MOT Centres",
      "Motor Dealers",
      "Motor Auctioneers",
      "Salvage Dealers",
      "Finance Companies",
      "Fleet Operators",
      "Car Buying Services",
    ],
    icon: <Enquiry />,
  },
  {
    title: "Feedback",
    path: "/feedback",
    toShowForRole: [
      "Personal",
      "Employee",
      "Commercial",
      "Corporate",
      "Lawyers",
      "Insurance Companies",
      "MOT Centres",
      "Motor Dealers",
      "Motor Auctioneers",
      "Salvage Dealers",
      "Finance Companies",
      "Fleet Operators",
      "Car Buying Services",
    ],
    icon: <Feedback />,
  },
];
// Show all notifications (header) mock data
export const Notify: RouteInfo[] = [
  {
    title: "PCN Issued",
    description: "You have a new PCN no AB123456789",
    path: "",
    date: "today",
    hours: "5 hours ago",
  },
  {
    title: "14 Days Limit",
    description: "Your PCN no GR 2345678109 is reaching 14 days limit",
    path: "",
    date: "today",
    hours: "3 hours ago",
  },
  {
    title: "PCN Payment ",
    description: "Your PCN no QW123456789  has been paid",
    path: "",
    date: "today",
    hours: "12 hours ago",
  },
  {
    title: "PCN Payment Limit ",
    description: "Pay your PCN RT123456789 within 14 days",
    path: "",
    date: "yesterday",
    hours: "5 hours ago",
  },
];
